const defaultState = () => ({
  history: [],
});

const modalsModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET_HISTORY(state, { currentModal }) {
      state.history.unshift(currentModal);
      state.history = state.history.slice(0, 3);
    },
    CLEAR_HISTORY(state) {
      state.history = [];
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    MODAL_HISTORY({ commit }, currentModal) {
      commit('SET_HISTORY', { currentModal });
    },
    MODAL_HISTORY_CLEAR({ commit }) {
      commit('CLEAR_HISTORY');
    },
  },
};

export default modalsModule;
